import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { WindowRef } from "@obg/ngx.global.evo";

export abstract class LocationService {
	abstract getOrigin(): string;

	abstract getPath(): string;

	abstract getHostName(): string;

	abstract navigate(url: string, target?: string, options?: string): void;

	abstract prepareExternalUrl(url: string): string;

	abstract reload(forcedReload?: boolean): void;
}

const TARGET_SELF = "_self";

@Injectable({
	providedIn: "root",
})
export class BrowserLocationService implements LocationService {
	constructor(
		private windowRef: WindowRef,
		private location: Location
	) {}

	getOrigin(): string {
		return this.windowRef.native.location.origin;
	}

	getPath(): string {
		return this.windowRef.native.location.pathname;
	}

	getHostName(): string {
		return this.windowRef.native.location.hostname;
	}

	navigate(url: string, target = TARGET_SELF, options?: string) {
		if (target === TARGET_SELF) {
			this.windowRef.native.location.href = url;
			return;
		}

		this.windowRef.native.open(url, target, options);
	}

	prepareExternalUrl(url: string) {
		return this.location.prepareExternalUrl(url);
	}

	reload() {
		this.windowRef.native.location.reload();
	}
}
